import styled from 'styled-components';

export const InvestorDetailsRowStyles = styled.div<{ $padding: string }>`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: ${({ $padding }) => $padding};
	border-radius: 0.25rem;
	min-width: 0;

	&.bordered {
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	}

	&.sm {
		line-height: 1rem;
	}

	> .label {
		flex: 0 1 auto;
		min-width: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	> .value {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		flex-wrap: nowrap;
		gap: 0.25rem;
		flex: 1 1 0;
		min-width: 0;
		text-align: right;
	}

	> .value > * {
		min-width: 0;
		overflow: hidden;
	}

	.copy {
		opacity: 0;
		flex-shrink: 0;
	}

	&:hover .copy,
	&:focus-within .copy {
		opacity: 1;
	}

	.details-value {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: block;
		min-width: 0;
		max-width: 100%;
	}
`;
